<!--
    作者：luoyiming
    时间：2020-04-20
    描述：修改价格
-->
<template>
  <div>
    <el-dialog
      title="分配客户"
      :visible.sync="dialogVisiblefpkh"
      @close="dialogFormVisible1"
      width="40%"
    >
      <el-select
        v-model="admin_id"
        placeholder="请选择"
        @change="fpchange($event)"
      >
        <el-option
          v-for="item in fplist"
          :key="item.id"
          :label="item.real_name"
          :value="item.shop_user_id"
        >
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblefpkh = false">取 消</el-button>
        <el-button type="primary" @click="fpsubmitFunc()" :loading="loading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js';
export default {
    data() {
        return {
            loading: false,
            dialogVisiblefpkh: true,
            admin_id:"",
            admin_name:""
        };
    },
    props: ['fplist', 'order_id', 'dxlist'],
    created() {
    },
    methods: {
        fpchange(e){
            // console.log(e);
            for (let data of this.fplist) {
                // console.log(data.id);
                if (data.shop_user_id == this.admin_id) {
                    console.log(data.real_name);
                    this.admin_name = data.real_name;
                }
            }
        },
        // 获取数据
        fpsubmitFunc() {
            let self = this;
            let orderList = self.dxlist.split(',');
            self.order_id 
                ? (orderList = [self.order_id])
                : orderList.pop();

            console.log({
                order_id: orderList,
                admin_id: self.admin_id,
                admin_name: self.admin_name
            })
            OrderApi.setadmin({
                order_id: orderList,
                admin_id: self.admin_id,
                admin_name: self.admin_name
            }, true).then(data => {
                self.loading = false;
                self.$message({
                    message: '修改成功',
                    type: 'success'
                });
                self.dialogFormVisible1(true);
            }).catch(error => {
                self.loading = false;
            });
        },

        /*关闭弹窗*/
        dialogFormVisible1() {
            this.$emit('close', { openDialog: false });
        },
    }

};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/fenpei.vue